if (!customElements.get('newsletter-modal')) {
  customElements.define(
    'newsletter-modal',
    class NewsletterModal extends ModalElement {
      constructor() {
        super();
    
        // Prevent popup on Shopify robot challenge page
        if (window.location.pathname === '/challenge' || !theme.cookiesEnabled) {
          return;
        }
    
        if (!theme.config.isTouch || Shopify.designMode) {
          this.init();
        }
        else {
          new theme.initWhenVisible(theme.utils.throttle(this.init.bind(this)));
        }
      }
    
      get shouldLock() {
        return true;
      }
    
      get testMode() {
        return this.getAttribute('data-test-mode') === 'true';
      }
    
      get delay() {
        return this.hasAttribute('data-delay') ? parseInt(this.getAttribute('data-delay')) : 5;
      }
    
      get expiry() {
        return this.hasAttribute('data-expiry') ? parseInt(this.getAttribute('data-expiry')) : 30;
      }
    
      get cookieName() {
        return 'concept:newsletter-popup';
      }
    
      get submited() {
        return this.querySelector('.alert') !== null;
      }
    
      init() {
        if (this.initialized) return;
        this.initialized = true;
        
        // Open modal if errors or success message exist
        if (this.submited) {
          this.load(1);
          return;
        }
    
        if (this.testMode) {
          this.load(this.delay);
          return;
        }

        // Fechado nos últimos 30 dias (cookie gravado em afterHide): não abre.
        if (this.getCookie(this.cookieName)) return;

        if (this.getAttribute('data-trigger') === 'engaged') {
          this.waitForEngagement();
        }
        else {
          this.load(this.delay);
        }
      }

      get sessionKey() {
        return 'eleven:newsletter-popup:shown';
      }

      get scrollDepth() {
        const depth = parseInt(this.getAttribute('data-scroll-depth'), 10);
        return Number.isNaN(depth) ? 0.5 : depth / 100;
      }

      // Eleven: nunca na primeira vista. Abre só depois do atraso (segundos) E da rolagem
      // mínima, e no máximo uma vez por sessão.
      waitForEngagement() {
        if (Shopify.designMode) return;
        try {
          if (window.sessionStorage.getItem(this.sessionKey)) return;
        } catch (error) {}

        let timeReached = false;
        let scrollReached = false;

        const tryOpen = () => {
          if (!timeReached || !scrollReached || this.open) return;
          window.removeEventListener('scroll', onScroll);
          try {
            window.sessionStorage.setItem(this.sessionKey, 'true');
          } catch (error) {}
          this.show();
        };

        const onScroll = () => {
          const scrollable = document.documentElement.scrollHeight - window.innerHeight;
          const depth = scrollable > 0 ? window.scrollY / scrollable : 0;
          if (depth >= this.scrollDepth) {
            scrollReached = true;
            tryOpen();
          }
        };

        window.addEventListener('scroll', onScroll, { passive: true });
        setTimeout(() => {
          timeReached = true;
          onScroll();
        }, this.delay * 1000);
      }
    
      load(delay) {
        if (Shopify.designMode) return;
    
        setTimeout(() => this.show(), delay * 1000);
      }
    
      afterShow() {
        super.afterShow();
        this.classList.add('show-image');
      }
    
      afterHide() {
        super.afterHide();
        this.classList.remove('show-image');
    
        // Remove a cookie in case it was set in test mode
        if (this.testMode) {
          this.removeCookie(this.cookieName);
          return;
        }
    
        this.setCookie(this.cookieName, this.expiry);
      }
    
      getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null;
      }
    
      setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${(expiry * 24 * 60 * 60)}; path=/`;
      }
    
      removeCookie(name) {
        document.cookie = `${name}=; max-age=0`;
      }
    }
  );
}
